export class EventAttendee {
    constructor(json?: any) {
        this.id = json && json.id || null;
        this.appUserID = json && json.app_user_id || null;
        this.firstName = json && json.first_name || null;
        this.lastName = json && json.last_name || null;
        this.profileImage = json && json.profile_image || null;
        this.eventID = json && json.event_id || null;
        this.attendingStatusID = json && json.attending_status_id || null;
        this.attendingStatus = json && json.attending_status || null;
    }

    id: number;
    appUserID: number;
    firstName: string;
    lastName: string;
    profileImage: string;
    eventID: number;
    attendingStatusID: number;
    attendingStatus: string;
}